import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';
export const CompanyHubAnnouncementBannerStatusQuery: GraphQLTaggedNode = graphql`
	query CompanyHubAnnouncementBannerStatusQuery($bannerId: String!) {
		adminAnnouncementBannerSetting(id: $bannerId) {
			id
			status
		}
	}
`;
